import styles from './RangeSettings.module.scss';
import saveSvg from './assets/save.svg';
import { yupResolver } from '@hookform/resolvers/yup';
import cn from 'classnames';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const schema = yup
  .object({
    min: yup.number().required(),
    max: yup.number().required(),
  })
  .required();

const RangeSettings = ({ rangeSettings, setRangeSettings }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...rangeSettings,
    },
    mode: 'all',
  });

  const onSubmit = (data) => {
    setRangeSettings(data);

    reset(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.settings}>
        <div className={styles.column}>
          <label>Min</label>

          <input type="text" inputMode="numeric" {...register('min')} className={cn(errors.min && styles.error)} />
        </div>
        <div className={styles.column}>
          <label>Max</label>

          <input type="text" inputMode="numeric" {...register('max')} className={cn(errors.max && styles.error)} />
        </div>
        <div className={styles.column}>
          <label>Step</label>

          <select {...register('step')}>
            <option>1</option>
            <option>0.1</option>
            <option>0.01</option>
            <option>0.001</option>
            <option>0.0001</option>
            <option>0.00001</option>
          </select>
        </div>
        <div className={styles.button}>
          <button disabled={!isDirty || errors.min || errors.max}>
            <img src={saveSvg} alt="Save" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default RangeSettings;
